var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerTable1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.779541,
    y: 0.208984,
    width: 95.0013,
    height: 95.0013,
    fill: "#42D27B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.779541,
    y: 0.208984,
    width: 95.0013,
    height: 95.0013,
    fill: "white",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Overlay",
    x: 10.0159,
    y: 9.44531,
    width: 76.5288,
    height: 76.5288,
    rx: 38.2644,
    fill: "white",
    fillOpacity: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerTable1);
export default __webpack_public_path__ + "static/media/customer_table1.c282f24d3da5236413ba78a613445bd2.svg";
export { ForwardRef as ReactComponent };